import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

export const StyledUserInfoCard = styled(Card)(() => ({
  width: '400px',
  borderRadius: '10px',
  boxShadow: '0 0 6px rgba(125, 137, 157, 0.25)',
}));
